// extracted by mini-css-extract-plugin
export var boxItems = "_1r-1";
export var button = "_1r-5";
export var filterGroupBox = "_1r-0";
export var icon = "_1r-2";
export var iconSecondary = "_1r-4";
export var iconWrapper = "_1r-3";